import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
    selector: 'gl-icon-checkbox',
    templateUrl: './icon-checkbox.component.html',
    styleUrls: ['./icon-checkbox.component.scss'],
    standalone: false
})
export class IconCheckboxComponent {

  @Input() public checkboxFormGroup: UntypedFormGroup;
  @Input() public tooltipInfo = '';
  @Input() public controlName = ''
  @Input() public iconName = ''
}
